import { FunctionComponent, RefObject } from 'react';
import { Loading } from '../../atoms/loading';
import { Paginate } from '../../molecules/paginate';
import { RecruitmentContent } from '../../organisms/recruitmentContent';
import type { Props as ComponentProps } from './types';

const PAGINATE_PER = 20;

type Props = ComponentProps & {
  paginatedRecruitmentIds: number[];
  handlePaginateClick: (page: number) => void;
  onFirstLoad?: () => void;
  articlesListInnerRef: RefObject<HTMLUListElement>;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  const startIndex = (props.page - 1) * PAGINATE_PER;

  return (
    <>
      <div className="articles-list">
        {props.loading && (
          <div className="articles-list__loading-overlay">
            <Loading />
          </div>
        )}
        {!props.loading && props.recruitment_ids.length === 0 ? (
          <div className="empty">
            <h3 className="empty__title">該当する求人が見つかりませんでした</h3>
            <div className="empty__contents">
              <p>条件を変更して、求人を探してみましょう。</p>
            </div>
          </div>
        ) : (
          <ul className="articles-list-inner" ref={props.articlesListInnerRef}>
            {props.paginatedRecruitmentIds.map((recruitmentId, index) => (
              <RecruitmentContent
                key={index === 0 ? `${recruitmentId}-p${props.page}` : recruitmentId}
                recruitment_id={recruitmentId}
                noimage={props.noimage}
                hoverIcon={props.hoverIcon}
                isPc={props.isPc}
                isCompany={props.isCompany}
                page={props.page}
                isBrandPage={props.isBrandPage}
                isStopped={props.isStopped}
                dataCategory={props.dataCategory}
                dataValue={props.dataValue}
                recruitmentNumber={startIndex + index + 1}
                dataClickPoint={props.dataClickPoint}
                dataListType="normal"
                sort={props.sort}
                isShowAttentionPeople={props.isShowAttentionPeople}
                onLoad={index === 0 ? props.onFirstLoad : undefined}
              />
            ))}
          </ul>
        )}
        {props.recruitment_ids.length > 0 &&
          Math.floor((props.recruitment_ids.length - 1) / PAGINATE_PER) !== 0 && (
            <Paginate
              current={props.page}
              max={Math.ceil(props.recruitment_ids.length / PAGINATE_PER)}
              handleClick={props.handlePaginateClick}
              page="companyIndex"
            />
          )}
        {!props.loading &&
          props.recruitment_ids.length <= PAGINATE_PER &&
          props.similar_recruitment_ids &&
          props.similar_recruitment_ids.length > 0 && (
            <section className="articles-list-similar">
              <h2 className="articles-list-similar__title">いまの検索条件の類似求人</h2>
              <ul className="articles-list-inner">
                {props.similar_recruitment_ids.map((recruitmentId) => (
                  <RecruitmentContent
                    key={`similar-${recruitmentId}`}
                    recruitment_id={recruitmentId}
                    noimage={props.noimage}
                    hoverIcon={props.hoverIcon}
                    isPc={props.isPc}
                    isCompany={props.isCompany}
                    page={props.page}
                    isBrandPage={props.isBrandPage}
                    isStopped={props.isStopped}
                    dataCategory={props.dataCategory}
                    dataValue={props.dataValue}
                    dataClickPoint={props.dataClickPoint}
                    dataListType="similar"
                    sort={props.sort}
                    isShowAttentionPeople={props.isShowAttentionPeople}
                  />
                ))}
              </ul>
            </section>
          )}
      </div>
    </>
  );
};
